var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5H3C2.58638 6.5 2.20284 6.64006 1.92145 6.92145C1.64006 7.20284 1.5 7.58638 1.5 8C1.5 8.41362 1.64006 8.79716 1.92145 9.07855C2.20284 9.35994 2.58638 9.5 3 9.5H13C13.4136 9.5 13.7972 9.35994 14.0786 9.07855C14.3599 8.79716 14.5 8.41362 14.5 8C14.5 7.58638 14.3599 7.20284 14.0786 6.92145C13.7972 6.64006 13.4136 6.5 13 6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.60d39f69731423bf78d4a7230ca5641d.svg";
export { ForwardRef as ReactComponent };